var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#8D95A1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43152 28.0001L11.1983 18.0001C11.8494 17.3335 13.5423 16.4001 15.105 18.0001C16.6677 19.6001 22.2673 25.3335 24.8718 28.0001",
    stroke: "",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4535 23.5L25.1974 19.7306C25.74 19.1793 27.1508 18.4074 28.453 19.7306C29.7552 21.0537 30.5149 21.2948 32.6853 23.5",
    stroke: "",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7786 4H36.592",
    stroke: "",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6853 8L32.6853 0",
    stroke: "",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6545 4H7.43152C4.11781 4 1.43152 6.68629 1.43152 10V30C1.43152 33.3137 4.11781 36 7.43152 36H26.6852C29.9989 36 32.6852 33.3137 32.6852 30V15.2941",
    stroke: "",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.9884,
    y: 11,
    width: 1.95335,
    height: 2,
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileUpload);
export default __webpack_public_path__ + "static/media/icon-file-upload.723817353c7eda44d3530b61fb79367c.svg";
export { ForwardRef as ReactComponent };